/* eslint-disable spaced-comment,@scandipwa/scandipwa-guidelines/jsx-no-props-destruction */
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import { Field as SourceField } from 'SourceComponent/Field/Field.component';

import { FIELD_TYPE } from './Field.config';

import './Field.style';

/**
 * Field
 * @class Field
 * @namespace Pwa/Component/Field/Component */
export class Field extends SourceField {
    __construct() {
        this.togglePasswordVisibility = this.togglePasswordVisibility.bind(this);
    }

    state = {
        passwordVisible: false
    };

    renderMap = {
        // Checkboxes & Radio
        [FIELD_TYPE.radio]: this.renderCheckboxOrRadio.bind(this),
        [FIELD_TYPE.checkbox]: this.renderCheckboxOrRadio.bind(this),
        [FIELD_TYPE.multi]: this.renderCheckboxOrRadio.bind(this),

        // Default input
        [FIELD_TYPE.email]: this.renderDefaultInput.bind(this),
        [FIELD_TYPE.text]: this.renderDefaultInput.bind(this),
        [FIELD_TYPE.time]: this.renderDefaultInput.bind(this),
        [FIELD_TYPE.dateTime]: this.renderDefaultInput.bind(this),
        [FIELD_TYPE.date]: this.renderDefaultInput.bind(this),
        [FIELD_TYPE.password]: this.renderPasswordInput.bind(this),
        [FIELD_TYPE.submit]: this.renderDefaultInput.bind(this),

        // Custom fields
        [FIELD_TYPE.file]: this.renderFile.bind(this),
        [FIELD_TYPE.select]: this.renderSelect.bind(this),
        [FIELD_TYPE.textarea]: this.renderTextArea.bind(this),
        [FIELD_TYPE.button]: this.renderButton.bind(this),
        [FIELD_TYPE.number]: this.renderNumber.bind(this)
    };

    componentDidMount() {
        const {
            attr: {
                defaultValue
            },
            onDefaultValueInit
        } = this.props;

        if (defaultValue && onDefaultValueInit) {
            onDefaultValueInit(defaultValue);
        }
    }

    componentDidUpdate(prevProps) {
        const {
            attr: {
                value
            },
            validate
        } = this.props;

        const {
            attr: {
                value: prevValue
            }
        } = prevProps;

        if (value !== prevValue) {
            validate();
        }
    }

    togglePasswordVisibility(event) {
        const { passwordVisible } = this.state;
        const passwordInput = event.target.previousElementSibling;
        passwordInput.type = passwordInput.type === 'password' ? 'text' : 'password';
        this.setState({ passwordVisible: !passwordVisible });
    }

    renderPasswordInput() {
        const { passwordVisible } = this.state;

        const {
            type,
            setRef,
            attr,
            events,
            isDisabled
        } = this.props;

        return (
            <>
                <input
                  ref={ (elem) => setRef(elem) }
                  disabled={ isDisabled }
                  type={ type }
                  { ...attr }
                  { ...events }
                />
                <span
                  className={ `password-show-hide ${passwordVisible ? 'show-password' : ''}` }
                  onClick={ this.togglePasswordVisibility }
                />
            </>
        );
    }

    //#region INPUT TYPE RENDER
    renderDefaultInput() {
        const {
            type,
            setRef,
            attr,
            events,
            isDisabled,
            bottomText,
            overheadText
        } = this.props;

        return (
            <>
                { overheadText && (
                    <div block="Field" elem="OverheadText">{ overheadText }</div>
                ) }
                <input
                  ref={ (elem) => setRef(elem) }
                  disabled={ isDisabled }
                  type={ type }
                  { ...attr }
                  { ...events }
                />
                { bottomText && (
                    <div block="Field" elem="BottomText">{ bottomText }</div>
                ) }
            </>
        );
    }
}

export default Field;
